<template>
  <div class="record">
    <div class="hear">
      <!--日历-->
      <div class="read-record-header">
        <div class="lf-img">
          <p>
            累计阅读 <span>{{ this.$store.getters.userInfo.readDays }}</span> 天
          </p>
        </div>
        <div class="calendar">
          <div class="date-btn" @click="_actionSelDate">
            {{ calendarCarData }}
            <span class="iconfont icon-xiajiantou grey-arrow"></span>
          </div>
          <van-calendar
            :key="calendarKey"
            class="calendar-info"
            :show-mark="false"
            :poppable="false"
            type="single"
            @select="dateSelect"
            :show-confirm="false"
            :show-subtitle="false"
            :show-title="false"
            :style="{ flex: 1 }"
            :min-date="minDate"
            :max-date="maxDate"
            :formatter="formatter"
            first-day-of-week="1"
            ref="myCalendar"
          />
        </div>
      </div>

      <!--说明-->
      <div class="desc-wrapper">
        <div class="desc-item">
          <i class="tag tag-read"></i>
          <span class="title">已读:</span>
          <span class="num">{{ read }}天</span>
        </div>
        <div class="desc-item">
          <i class="tag tag-unread"></i>
          <span class="title">未读:</span>
          <span class="num">{{ unRead }}天</span>
        </div>
      </div>
    </div>

    <!--已阅读文章列表-->
    <div class="down-footer">
      <ul class="list" v-if="readRecords.length > 0">
        <li class="cell" v-for="(item, index) in readRecords" :key="index">
          <h1 class="title" v-if="index == 0">已阅读文章</h1>
          <h2 v-if="item.extensionType" class="sub-title">
            — {{ getTopic(item.extensionType) }} —
          </h2>
          <p class="content">{{ item.title }}</p>
          <div class="btn-wrapper">
            <van-button
              class="btn btn-lf"
              type="info"
              @click="_actionStudyRecord(item)"
              >查看学习记录</van-button
            >
            <!-- <van-button
              class="btn btn-rg"
              type="info"
              @click="_actionShareRecord(item)"
              >分享学习记录</van-button
            > -->
          </div>
        </li>
      </ul>
      <van-empty v-else description="无阅读文章" />
    </div>

    <!--选择时间弹出层-->
    <van-popup v-model="show" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="year-month"
        title="选择年月"
        :min-date="selMinDate"
        :max-date="selMaxDate"
        :formatter="selDateFormatter"
        @confirm="selDateTime"
        @cancel="
          () => {
            this.show = false;
          }
        "
      />
    </van-popup>

    <!--学习记录弹出层-->
    <van-overlay :z-index="120" :show="showRecord">
      <div class="wrapper">
        <div class="block">
          <div style="padding: 20px">
            <div class="overlay-title">
              <div class="alert-title">{{ perReadDate }}</div>
              <van-icon
                class="close-img"
                name="cross"
                @click="onClickHide"
                alt
              />
            </div>
            <van-divider />
            <div class="overlay-item">
              <div class="overlay-item-text-label">文章标题：</div>
              <div class="overlay-item-text-content">
                {{ this.recordResult.title }}
              </div>
            </div>
            <van-divider v-if="this.recordResult.difficultyTitle" />
            <div v-if="this.recordResult.difficultyTitle" class="overlay-item">
              <div class="overlay-item-text-label">文章难度：</div>
              <div
                style="font-weight: bold; color: #3994e7"
                class="overlay-item-text-content"
              >
                {{ this.recordResult.difficultyTitle }}
              </div>
            </div>
            <van-divider v-if="this.recordResult.answers" />
            <div v-if="this.recordResult.answers" class="overlay-item">
              <div class="overlay-item-text-label">答题成绩：</div>
              <div class="overlay-item-text-content">
                <span style="font-weight: bold; color: #3994e7"
                  >{{ this.recordResult.correct }}/{{
                    this.recordResult.answers
                  }}</span
                >
                <span>
                  【准确率
                  <span style="font-weight: bold; color: #3994e7"
                    >{{ perAccuracyRate }}%</span
                  >
                  】
                </span>
              </div>
            </div>
            <!--            <van-divider v-if="this.recordResult.readingSpeed"/>-->
            <!--            <div v-if="this.recordResult.readingSpeed" class="overlay-item">-->
            <!--              <div class="overlay-item-text-label">阅读速度：</div>-->
            <!--              <div-->
            <!--                style="font-weight:bold;color:blue"-->
            <!--                class="overlay-item-text-content"-->
            <!--              >{{this.recordResult.readingSpeed}}词/分</div>-->
            <!--            </div>-->
          </div>
          <!-- <div class="alert-btn-wrapper">
            <van-button
              class="btn lf-btn"
              round
              block
              type="primary"
              @click="_actionReRead()"
              >重新阅读答题</van-button
            >
            <van-button
              class="btn rg-btn"
              round
              block
              type="warning"
              @click="_actionShareReadRecord()"
              >分享学习记录</van-button
            >
          </div> -->
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
// import {} from "@/api/userArticle";

import moment from "moment";
import _ from "lodash";
import { ShareSource } from "@/contants";
import {
  getV2CalendarMonthByUserId,
  getV2UserArticleSomeday,
  getV2ReadArticleDetailByUserId,
  getUserArticleCalendarSomedayByUserId,
  getUserArticleCalendarUser,
} from "@/api/userArticle";

import { getCalendarShareInfo } from "@/api/share";
export default {
  data() {
    return {
      show: false, //展示时间选择器
      showRecord: false, //展示学习记录
      calendarCarData: "", //日历上显示的年月

      //日历打卡数据
      readDays: [],
      read: 0,
      unRead: 0,

      //日历
      minDate: new Date(),
      maxDate: new Date(2010, 1, 31),
      calendarKey: moment().unix(),

      selMinDate: new Date(2020, 0, 1),
      selMaxDate: new Date(2025, 10, 1),

      //选择的日期,默认是当前时间
      currentDate: new Date(),

      //选择的某日的阅读记录
      readRecords: [],

      //阅读记录详情
      recordResult: {
        issueDate: "",
        title: "",
        difficultyTitle: "480L",
        score: "2/4",
        accuracyRate: "50%",
        answers: {},
      },
    };
  },

  computed: {
    //详情-答题日期
    perReadDate() {
      return moment(this.recordResult.issueDate).format("YYYY/MM/DD");
    },
    //详情=答题准确率
    perAccuracyRate() {
      return (
        (this.recordResult.correct * 100) /
        this.recordResult.answers
      ).toFixed(1);
    },
  },

  created() {
    //初始数据
    const curDate = new Date();
    this.calendarCarData = moment(curDate).format("YYYY年MM月");
    this.minDate = moment(curDate).startOf("month").toDate();
    this.maxDate = moment(curDate).endOf("month").toDate();
    this.request_getUserArticleCalendarSomeday();
  },

  activated() {
    //加载所选月份的阅读日历
    // this.request_getUserArticleCalendarSomeday();
  },

  mounted() {
    //格式化日期
    this.formatWeek();
  },

  methods: {
    //===============Net==================
    //加载所选月份的阅读日历
    request_getUserArticleCalendarSomeday() {
      console.log("=====>", this.$router.currentRoute.query.userId);
      let params = {
        timestamp: moment(this.currentDate).valueOf(),
        userId: this.$router.currentRoute.query.userId,
      };
      getV2CalendarMonthByUserId(params).then((res) => {
        const { readDays, read, unRead } = res.data || {};
        this.readDays = readDays;
        this.read = read;
        this.unRead = unRead;

        //刷新日历
        // this.$refs.myCalendar.reset();
        // this.calendarKey = moment().unix();

        //检测今天是否有阅读记录,如果有则展示
        if (!this.readDays || (this.readDays && this.readDays.length == 0)) {
          return;
        }

        const nowDate = moment().format("YYYY-MM-DD");
        for (let i = 0; i < this.readDays.length; i++) {
          let item = this.readDays[i];
          const formatItem = moment(item).format("YYYY-MM-DD");
          console.log("********", nowDate, formatItem);
          if (formatItem == nowDate) {
            this.currentDate = moment().toDate();
            this.request_getV2UserArticleSomeday();
            break;
          }
        }
      });
    },

    //获取某日阅读文章记录
    request_getV2UserArticleSomeday() {
      let params = {
        timestamp: moment(this.currentDate).valueOf(),
        userId: this.$router.currentRoute.query.userId,
      };
      this.$loading.show();
      getUserArticleCalendarSomedayByUserId(params)
        .then((res) => {
          this.$loading.hide();
          this.readRecords = res.data || [];
        })
        .catch((err) => {
          this.$loading.hide();
        });
    },

    //获取谋篇阅读记录详情
    request_getGetV2ReadArticleDetail(item) {
      this.$loading.show();
      let params = {
        articleId: item.articleId,
        timestamp: item.readDate,
        userId: this.$router.currentRoute.query.userId,
      };
      getV2ReadArticleDetailByUserId(params)
        .then((res) => {
          this.$loading.hide();
          this.recordResult = res.data || {};
          this.recordResult.readRecord = item;
          this.showRecord = true;
        })
        .catch((err) => {
          this.$loading.hide();
        });
    },

    //获取阅读记录的详情
    //============handleData==============
    //获取话题
    getTopic(type) {
      if (type == 1) {
        return "科学";
      } else if (type == 2) {
        return "艺术";
      } else if (type == 3) {
        return "人文";
      } else {
        return "";
      }
    },

    //===============action=================
    //点击关闭阅读记录
    onClickHide() {
      this.showRecord = false;
    },

    //查看学习记录
    _actionStudyRecord(item) {
      this.request_getGetV2ReadArticleDetail(item);
    },

    //重新阅读答题
    _actionReRead() {
      this.$router.push({
        path: "/articleGuide",
        query: { articleId: this.recordResult.articleId },
      });
    },

    //分享学习记录
    _actionShareReadRecord() {
      console.log("=++++aaa++===>", this.recordResult);
      getCalendarShareInfo({
        articleId: this.recordResult.articleId,
        shareSource: ShareSource.RECORD_SELF_CALENDAR,
        readDate: this.recordResult.readRecord.readDate,
      }).then((res) => {
        this.$router.push({
          path: "/share/dailyReport",
          query: {
            shareReadRecordId: res.data.businessId,
            shareRecordId: res.data.shareRecordId,
            bySelf: true,
          },
        });
      });
    },
    _actionShareRecord(item) {
      getCalendarShareInfo({
        articleId: item.articleId,
        shareSource: ShareSource.RECORD_SELF_CALENDAR,
        readDate: item.readDate,
      }).then((res) => {
        this.$router.push({
          path: "/share/dailyReport",
          query: {
            shareReadRecordId: res.data.businessId,
            shareRecordId: res.data.shareRecordId,
            bySelf: true,
          },
        });
      });
    },

    //===============选择日期=================
    //格式化 一 二 三 四 五 六 日
    formatWeek() {
      this.$nextTick(() => {
        const arr = ["MON", "TUE", "WED", "THU", "FRL", "SAT", "SUN"];
        var divs = document.getElementsByClassName("van-calendar__weekday");
        for (let i = 0; i < divs.length; i++) {
          divs[i].innerHTML = arr[i];
        }
      });
    },

    //选择月份
    selDateTime(value) {
      this.show = false;

      this.calendarKey = moment().unix();
      this.calendarCarData = moment(value).format("YYYY年MM月");
      this.minDate = value;
      this.maxDate = moment(value).endOf("month").toDate();

      //从新格式化日期
      this.formatWeek();

      //清空下方文章阅读历史
      this.readRecords = [];

      //刷新日历
      this.currentDate = moment(value).toDate();
      this.request_getUserArticleCalendarSomeday();
    },

    selDateFormatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      }
      return val;
    },

    //================calendar===============
    //点击选择日期
    _actionSelDate() {
      this.show = true;
    },

    //点击日历的item
    dateSelect(value) {
      this.currentDate = moment(value).toDate();
      const readDate = _.find(this.readDays, (item) => {
        return (
          moment(value).format("YYYY-MM-DD") ==
          moment(item).format("YYYY-MM-DD")
        );
      });
      if (readDate) {
        //已读
        //获取选择日期的阅读记x录
        this.request_getV2UserArticleSomeday();
      } else {
        //未读
        this.readRecords = [];
      }
    },

    //通过传入formatter函数来对日历上每一格的内容进行格式化
    formatter(day) {
      day.className = "calender-unread";
      let now = moment();
      if (!this.readDays || this.readDays.length == 0) {
        if (day.date > now) {
          day.className = "calender-normal";
        }

        if (day.type == "selected") {
          day.type = "";
          day.className = "calender-bu";
        }
        return day;
      }

      const itemYMD = moment(day.date).format("YYYY-MM-DD");
      for (let i = 0; i < this.readDays.length; i++) {
        let item = this.readDays[i];
        if (day.date > now) {
          day.className = "calender-normal";
        }
        const formatItem = moment(item).format("YYYY-MM-DD");
        if (formatItem == itemYMD) {
          day.className = "calender-read";
          break;
        }
      }

      if (day.type == "selected") {
        day.type = "";
        day.className = "calender-bu";
      }

      return day;
    },
  },
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.record {
  min-height: 100vh;
  box-sizing: border-box;
  position: relative;
}

.hear {
  width: 100%;
}

.read-record-header {
  display: flex;

  .lf-img {
    width: 90px;
    height: 240px;
    background: url('../../assets/imgs/record/record_lf_bg.png') no-repeat;
    background-size: cover;

    p {
      width: 20px;
      margin: 0 auto;
      line-height: 24px;
      font-size: 14px;
      text-align: center;
      position: relative;
      top: 50%;
      transform: translateY(-50%);
      color: #fff;
      font-family: serif;
      font-weight: bold;
      text-shadow: 2px 2px 2px #000000;

      span {
        font-size: 18px;
      }
    }
  }

  .calendar {
    flex: 1;
    display: flex;
    flex-direction: column;
    height: 240px;
    background-color: #FBF7F6;

    .date-btn {
      font-size: 14px;
      font-weight: bold;
      font-family: serif;
      text-align: right;
      padding: 12px 16px 8px;

      & >>> .grey-arrow {
        width: 18px;
        color: #999999;
      }
    }

    .calendar-info {
      background-color: #FBF7F6;
    }

    & >>> .van-calendar__month-title {
      display: none;
    }

    & >>> .van-calendar__header-subtitle {
      padding-top: 10px;
      padding-right: 16px;
      padding-bottom: 0;
      text-align: right;
    }

    & >>> .van-calendar__header {
      box-shadow: none;
    }

    & >>> .van-calendar__weekday {
      font-size: 12px;
      transform: scale(0.8);
    }

    & >>> .van-calendar__day {
      font-size: 12px;
      transform: scale(0.8);
      height: 0.7rem;
    }

    & >>> .calender-read {
      position: relative;
      font-weight: bold;
      z-index: 11;
      color: #fff;

      &::before {
        box-sizing: border-box;
        content: '';
        display: block;
        position: absolute;
        width: 20px;
        height: 20px;
        border-radius: 50px;
        z-index: -10;
        background: linear-gradient(top, #98CEFF, #3994E7);
      }
    }

    & >>> .calender-normal {
      position: relative;
      font-weight: bold;
      z-index: 11;
    }

    & >>> .calender-unread {
      position: relative;
      font-weight: bold;
      z-index: 11;
      color: #d4d4d4;
    }

    & >>> .calender-unused {
      position: relative;
      font-weight: bold;
      z-index: 11;

      &::before {
        box-sizing: border-box;
        content: '';
        display: block;
        position: absolute;
        width: 20px;
        height: 20px;
        border-radius: 14px;
        color: #fff;
        z-index: -10;
        background-color: #F3F3F3;
      }
    }

    & >>> .calender-bu {
      position: relative;
      font-weight: bold;
      z-index: 11;
      color: #5597EC;

      &::before {
        box-sizing: border-box;
        content: '';
        display: block;
        position: absolute;
        width: 20px;
        height: 20px;
        border: 1.5px solid #5597EC;
        border-radius: 14px;
        color: #fff;
        z-index: -10;
      }
    }
  }
}

.down-footer {
  width: 100%;
  overflow: scroll;
}

.desc-wrapper {
  box-sizing: border-box;
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 40px;
  line-height: 40px;

  .desc-item {
    display: flex;
    align-items: center;
    font-size: 12px;
    transform: scale(0.8);

    .tag {
      width: 16px;
      height: 16px;
      border-radius: 50px;
    }

    .tag-read {
      background: linear-gradient(top, #98CEFF, #3994E7);
    }

    .tag-unread {
      background-color: #D0D0D0;
    }

    .title {
      margin: 0 10px;
    }
  }
}

.down-footer {
  margin-bottom: 60px;
  width: 100%;
  overflow: scroll;
}

.cell {
  border-top: 10px solid #F3F3F3;
  background-color: #fff;
  padding: 17px 20px;
  text-align: center;

  .title {
    font-size: 18px;
    color: #333333;
    font-weight: bold;
    margin-bottom: 20px;
  }

  .sub-title {
    font-size: 11px;
    color: #999999;
    margin-bottom: 6px;
  }

  .content {
    font-size: 14px;
    color: #999999;
  }

  .btn-wrapper {
    margin-top: 17px;
    display: flex;
    justify-content: space-around;
  }

  .btn {
    border-radius: 50px;
    font-size: 12px;
    height: 34px;
  }

  .btn-lf {
    background-color: #fff;
    color: #3994E7;
    border-color: #3994E7;
  }

  .btn-rg {
    border: none;
    background-image: linear-gradient(to right, #3994E7, #98CEFF);
  }
}

/* 学习记录蒙层 */
.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-content: center;
  height: 100%;

  .block {
    margin: 30px;
    width: 84%;
    border: 1px solid #cccccc;
    border-radius: 14px;
    background-color: #fff;
    position: relative;
  }

  .overlay-title {
    display: flex;
    flex-direction: row;
    font-size: 18px;
    font-weight: bold;
    justify-content: center;
  }

  .overlay-item {
    display: flex;
    flex-direction: row;
    font-size: 13px;
  }

  .overlay-item-text-label {
    font-weight: bold;
  }

  .overlay-item-text-content {
    flex: 1;
    text-align: justify;
    text-justify: newspaper;
    word-break: break-word;
    color: #333333;
    font-weight: bold;
  }

  .close-img {
    position: absolute;
    right: 10px;
    top: 20px;
    width: 36px;
    height: 36px;
    color: #999999;
  }

  .alert-btn-wrapper {
    margin: 6px 0 22px;
    width: 100%;
    display: flex;
    justify-content: space-around;

    .btn {
      width: 40%;
    }

    .lf-btn {
      color: #3994E7;
      background-color: #fff;
      border: 1px solid #3994E7;
    }

    .rg-btn {
      color: #fff;
      background-image: linear-gradient(to right, #3994E7, #98CEFF);
      border: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// app/pages/family/ChildReadDetail.vue